import { render, staticRenderFns } from "./checkbox-modal-cancel-btn.mpx?vue&type=template&id=fe7b8552&isComponent&outputPath=components%2Fcheckbox-modal-cancel-btn70b5c1ac%2Findex"
import script from "./checkbox-modal-cancel-btn.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fcheckbox-modal-cancel-btn70b5c1ac%2Findex"
export * from "./checkbox-modal-cancel-btn.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fcheckbox-modal-cancel-btn70b5c1ac%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports